import { useEffect, useState } from "react";
import { useOutletContext } from "react-router-dom";
import api, { fmtNZD } from "@/lib/api";

export default function FinancialsTab() {
  const { project } = useOutletContext();
  const [summary, setSummary] = useState(null);
  useEffect(() => {
    api.get(`/projects/${project.id}/financials-summary`).then(r => setSummary(r.data)).catch(() => {});
  }, [project.id]);
  if (!summary) return <div className="opacity-60">Loading…</div>;
  return (
    <div className="card space-y-2" data-testid="financials-tab">
      <h3 className="text-silver mb-2">Financials summary</h3>
      <Row k="Original contract" v={fmtNZD(summary.original_contract)}/>
      <Row k="Approved variations" v={fmtNZD(summary.approved_variations)}/>
      <Row k="Current contract total" v={fmtNZD(summary.current_contract_total)} bold/>
      <Row k="Estimate net cost (ex GST)" v={fmtNZD(summary.estimate_net_cost)}/>
      <Row k="Costs so far" v={fmtNZD(summary.costs_so_far)}/>
    </div>
  );
}
function Row({ k, v, bold }) {
  return <div className={`flex justify-between ${bold ? "font-bold text-silver" : ""}`}><span>{k}</span><span>{v}</span></div>;
}
